const loadPage = (page) => {
  const select = document.querySelector(`#${page} #site`)
  let url = `/admin/lists/${page}?feast=${document.querySelector('select[name="feast"]').value}`
  if (select) url += `&site=${select.value}`

  const pane = document.querySelector(`#${page}`)
  pane.innerHTML = '<div class="lead"><i class="fa fa-spinner fa-spin fa-5x"></i></div>'

  fetch(url)
    .then(resp => {
      if (resp.ok) return resp.text()
    })
    .then(text => {
      pane.innerHTML = text
      $('.select2').select2()
    })
}

const loadCurrentPage = () => {
  const activeTab = document.querySelector('.lists .tab-pane.active')
  if (activeTab) loadPage(activeTab.id)
}

addEventListener('DOMContentLoaded', loadCurrentPage)
$(document).on('shown.bs.tab', '.lists', loadCurrentPage)
$(document).on('change', '.tab-pane #site', ({ target }) => {
  loadPage(target.closest('.tab-pane').id)
})
